import { addMfeEventListener, dispatchMfeEvent } from './mfe-communication';
function log(...args) {
    if (localStorage.getItem('mfe-utils-multiple-router-utils-logger') === 'true') {
        console.log(...args);
    }
}
export function addApplicationRouterListener(injectionRoute, navigate) {
    return addMfeEventListener('route-change', (mfeEvent) => {
        log('<<< route-change event intercepted', mfeEvent);
        const location = mfeEvent.context.location;
        const pathName = location.pathname;
        log('< pathname', pathName);
        log('< injectionRoute', injectionRoute);
        //The pathname will look something like this: /mfe-1/page-1
        //The injectionRoute will look something like this: /mfe-1/*
        //We need to convert those strings into this: page-1
        //The trick is to make sure that injectionRoute ends with *.
        //If it does, we remove the star, and then do a search and replace on pathname to remove the application prefix.
        if (/\*$/.test(injectionRoute)) {
            //if it ends with a * then we can knock off everything previous.
            let innerRoute = '';
            if (/\/\*$/.test(injectionRoute) && pathName === injectionRoute.slice(0, -2)) {
                //There is a special case where the route is something like mfe-1/category and the injection route is mfe-1/category/*.
                //mfe-1/category should match mfe-1-category/* but that pesky slash as at the end. This case will ensure they still match.
                innerRoute = '/';
            }
            else {
                innerRoute = pathName.replace(injectionRoute.slice(0, -1), '');
            }
            log('< innerRoute', innerRoute);
            navigate(innerRoute);
            log('\n');
        }
    });
}
/**
 * If your MFE is injected into an application using the application-shell then
 * this function will allow you to change the route within the application using
 * the React router rather than changing the URL and forcing a page reload.
 * @param mfeName: The name of your mfe firing the event.
 * @param newRoute: The route to change the url to.
 */
export function appShellNavigate(mfeName, newRoute) {
    //Discussion:
    //Do we want to try to support the fallbackUrl?
    //If we support the fallbackUrl, then whatever is injecting the MFE won't need do do anything.
    //If we don't support the fallbackUrl, then when the MFE that is using appShellNavigate wants to
    //change the URL and is injected into something that is not the ApplicationShell, then this would
    //just be a no-op unless the shell code added an 'app-shell-navigate' event listener.
    //Decision: we will ship v1 with no fallbackUrl. Someday we might want to add it as an optional parameter.
    dispatchMfeEvent(mfeName, 'app-shell-navigate', { newRoute: newRoute });
}
/**
 * Takes the injection route of an MFE and combines it with the MFE's route
 * to crete a full URL to pass into a navigate function.
 * @example resolveMfeRoute('/mfe-1/*', 'page-1') returns '/mfe-1/page-1'
 * @param injectionRoute: The route at which the mfe is injected.
 * @param mfeRoute: The route within the MFE to go to.
 */
export function resolveMfeRoute(injectionRoute, mfeRoute) {
    return injectionRoute.replace('*', '') + mfeRoute;
}
